import { effect as peffect } from '@preact/signals-core';
import { implementService } from '../../helpers.js';
import { SignalsServiceDefinition, } from './definition.js';
export const SignalsServiceFactory = implementService(SignalsServiceDefinition, ({ config: { signalsRegistry }, }) => {
    return {
        signal: (initialValue) => {
            return signalsRegistry.createSignal(initialValue);
        },
        computed: (fn) => {
            return signalsRegistry.createComputedSignal(fn);
        },
        effect: peffect,
    };
});
